import * as React from 'react';
import { UitkText } from 'uitk-react-text';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { ConnectionAdditionalInformation } from 'types/shared';

interface FlightLayoverInfoProps {
  connectionAdditionalInformation: ConnectionAdditionalInformation;
  dataTestId?: string;
}

export const LayoverInfo = ({ connectionAdditionalInformation, dataTestId }: FlightLayoverInfoProps) => {
  const { durationAndStop, nextFlightOriginAirport } = connectionAdditionalInformation;

  return (
    <UitkLayoutFlex
      direction="column"
      space="one"
      className="all-l-padding-six all-t-padding-six"
      dataTestId={dataTestId}
    >
      <hr />
      <UitkLayoutFlexItem className={nextFlightOriginAirport ? 'all-t-padding-two' : 'all-y-padding-two'}>
        <UitkText size={300} inline={true}>
          {durationAndStop}
        </UitkText>
      </UitkLayoutFlexItem>

      {nextFlightOriginAirport && (
        <UitkLayoutFlexItem className="all-b-padding-two">
          <UitkText size={300} theme="negative" inline={true}>
            {nextFlightOriginAirport}
          </UitkText>
        </UitkLayoutFlexItem>
      )}

      <hr className="all-b-padding-three" />
    </UitkLayoutFlex>
  );
};
